 <script>
import lazyLoadComponent from '@router/lazyload-component'
import { formatGetTime } from '@utils/format-date'
import { merchantUserComputed, checkInComputed } from '@state/helpers'
import { messageStore, messageDelete } from '@utils/message'
import { messageBoxLeave } from '@utils/message-box'
import { notification } from '@utils/notification'

const initData = () => {
  return {
    avatar: '',
    name: '',
    title: '',
    phoneCode: '+886',
    phoneNumber: '',
    specialty: '',
    certificate: '',
    description: '',
    secretCode: '',
    secretCodeConfirm: '',
    takeOfficeDate: '',
    leaveOfficeDate: '',
    block: 0,
    maxCollision: 1,
    storeIds: [],
    serviceCategoryIds: [],
    productPriceIds: [],
    userGroups: [],
    userGroupIds: [],  // 帳號權限
    userGroupStoreIds: [],  // 分店 -> 當userGroupIds includes 12 此欄位必填
    // customerLimit: 1,
  }
}

const formatToFormData = ({ email, password = '', passwordConfirm = '', ...restData }) => {
  return {
    ...restData,
    account: email,
    secretCode: password,
    secretCodeConfirm: passwordConfirm,
  }
}

const formatSubmitData = ({ account, secretCode, secretCodeConfirm, ...restData }) => {
  return {
    ...restData,
    email: account,
    password: secretCode,
    passwordConfirm: secretCodeConfirm,
  }
}

export default {
  components: {
    BaseSteps: () => import('@components/BaseSteps'),
    BaseUpload: () => lazyLoadComponent(import('@components/BaseUpload')),
    CountryCodePicker: () => lazyLoadComponent(import('@components/CountryCodePicker')),
    ScheduleStaffServiceForm: () => lazyLoadComponent(import('@components/ScheduleStaff/ScheduleStaffServiceForm')),
    ScheduleStaffRolePermission: () => lazyLoadComponent(import('@components/ScheduleStaff/ScheduleStaffRolePermission')),
    Step2Info: () => lazyLoadComponent(import('@components/ScheduleStaff/Step2Info')),
    Step3Account: () => lazyLoadComponent(import('@components/ScheduleStaff/Step3Account')),
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => initData(),
    },
    type: {
      type: String,
      default: 'new',
    },
    accessType: {
      type: String,
      default: '',
    },
    accountId: {
      type: Number,
      default: 0,
    },
    isDialog: {
      type: Boolean,
      default: false
    },
    isSpace: {
      type: Boolean,
      default: false
    },
    fetchTypes: {
      type: Array,
      default : () => []
    }
  },
  
  data() {
    return {
      tryingStore: false,
      submitData: formatToFormData(Object.assign(initData(), this.defaultValue)),
      endDatePickerOptions: {
        disabledDate: (time) => {
          // check String or Date Object
          const selectedStartDate = this.submitData.takeOfficeDate instanceof Object ? this.submitData.takeOfficeDate : new Date(this.submitData.takeOfficeDate)
          return time < selectedStartDate
          // 下面是限定一年以後不給點選，先拔掉
          // const limitWith365Days = selectedStartDate.getTime() + 3600 * 1000 * 24 * 365
          // return time < selectedStartDate || time.getTime() >= limitWith365Days
        },
      },
      // activeTab: '1',
      passwordVisible: false,
      repasswordVisible: false,
      passwordEditable: false,
      allUserGroups: [],
      loadingStatus: false, // loading 狀態
      checkedPwd: false, // 確認變更密碼
      showCheckBox: false, // 看要不要顯示變更密碼按鈕,
      activeStep: 1,
      stepList: Object.freeze([
        {
          title: '選擇角色',
        },
        {
          title: '基本資訊',
        },
        {
          title: '帳號密碼',
        },
        {
          title: '服務項目',
        },
      ]),
      ScheduleStaffFormSettingStep: [
        'ScheduleStaffRolePermission',
        'Step2Info',
        'Step3Account',
        'ScheduleStaffServiceForm'
      ]
    }
  },
  computed: {
    ...merchantUserComputed,
    ...checkInComputed,
    // submitRules() {
    //   const isTaiwan = this.submitData.phoneCode === '+886'
    //   return {
    //     avatar: [
    //       {
    //         required: true,
    //         message: '請上傳頭像',
    //         trigger: 'change',
    //       },
    //     ],
    //     name: [
    //       {
    //         required: true,
    //         message: '請填寫姓名',
    //         trigger: 'blur',
    //       },
    //     ],
    //     account: [
    //       { required: true, message: '請輸入 Email', trigger: 'blur' },
    //       { type: 'email', message: '請輸入正確的 Email 格式', trigger: 'blur' },
    //     ],
    //     secretCode: [
    //       {
    //         required: !this.isEditMode,
    //         message: '請輸入密碼',
    //         trigger: 'blur',
    //       },
    //       {
    //         validator: (rule, value, callback) => {
    //           const passwordPattern = /^\S{8,16}$/
    //           if (!passwordPattern.test(value)) {
    //             callback(new Error('請使用 8~16 個大小寫英文字母、數字與特殊符號組合'))
    //           }
    //           if (this.submitData.secretCodeConfirm !== '') {
    //             this.$refs.form.validateField('secretCodeConfirm')
    //           }
    //           callback()
    //         },
    //         trigger: 'blur',
    //       },
    //     ],
    //     secretCodeConfirm: [
    //       {
    //         required: true,
    //         validator: (rule, value, callback) => {
    //           if (!value) return callback(new Error('請再次輸入密碼'))
    //           const passwordValue = this.submitData.secretCode
    //           if (value !== passwordValue) {
    //             callback(new Error('兩次輸入的密碼不一致'))
    //           }
    //           callback()
    //         },
    //         trigger: 'blur',
    //       },
    //     ],
    //     title: [
    //       {
    //         required: true,
    //         message: '請填寫職位',
    //         trigger: 'blur',
    //       },
    //     ],
    //     phoneCode: [
    //       {
    //         required: true,
    //         message: '請選擇電話國碼',
    //         trigger: 'change',
    //       },
    //     ],
    //     phoneNumber: [
    //       {
    //         required: true,
    //         message: '請填寫聯絡電話',
    //         trigger: 'blur',
    //       },
    //       {
    //         pattern: isTaiwan ? /^02\d{7,8}$|^09\d{8}$/ : '',
    //         message: '市話號碼格式請符合 02XXXXXXXX；手機號碼格式請符合 09XXXXXXXX',
    //         trigger: 'blur',
    //       },
    //     ],
    //     takeOfficeDate: [
    //       {
    //         validator: (rule, value, callback) => {
    //           if (this.submitData.takeOfficeDate) this.$refs.form.validateField('leaveOfficeDate')
    //           callback()
    //         },
    //         trigger: 'change',

    //       },
    //     ],
    //     leaveOfficeDate: [
    //       {
    //         validator: (rule, value, callback) => {
    //           if (this.submitData.takeOfficeDate && !!value) {
    //             const isSmallThanTakeOfficeDate = formatGetTime(this.submitData.takeOfficeDate) > formatGetTime(value)
    //             if (isSmallThanTakeOfficeDate) return callback(new Error('不得小於到職日期'))
    //           }
    //           callback()
    //         },
    //         trigger: 'change',
    //       },
    //     ],
    //     userGroupIds: [
    //       {
    //         required: true,
    //         message: '請選擇權限',
    //         // trigger: 'blur',
    //       },
    //     ],
    //     userGroupStoreIds: [
    //       {
    //         required: true,
    //         message: '請選擇負責分店',
    //         trigger: 'change',
    //       },
    //     ],
    //   }
    // },
    isEditMode() {
      return this.defaultValue.id
    },
    hasAdminPermission() {
      if (this.defaultValue.userGroupIds) {
        return this.defaultValue.userGroupIds.includes(7)
      }

      const userGroupIds = this.defaultValue.userGroups.map(({ id }) => id)
      return userGroupIds.includes(7)
    },
    hasBranchPermission() {
      return this.submitData.userGroupIds.includes(12) && this.submitData.userGroupStoreIds
    },
    /**
     * @description 因為怕使用者直接點擊頁面，跳過設定，所以新建時，就要擋其點選tab Name
     */
    clickTab() {
      if (this.isEditMode || (this.submitData.title && this.submitData.title.length > 0)) return true
      if (this.activeStep === 1 && !this.isEditMode) {
        return false
      } else {
        return true
      }
    }
  },
  watch: {
    defaultValue: 'updateSubmitData',
    activeStep(nvl, ovl) {
    }
  },
  async created() {
    this.allUserGroups = await this.$store.dispatch('merchant/fetchUserGroups')
    if (this.submitData.userGroupIds.length === 0) {
      this.submitData.userGroupIds = this.submitData.userGroups ? [...this.submitData.userGroups.map(item => item.id)] : []
    }
    this.submitData.phoneCode = '+886'

  },
  mounted() {
    if (!this.isEditMode || this.accountId !== 0) {
      this.passwordEditable = true
    }
    this.showPwdCheck()
    if (this.accessType === 'employee') this.activeStep = 2
  },
  methods: {
    /**
     * @description 點擊tab
     */
    handleClick(tab, event) {
      this.activeStep = tab.name
    },
    showPwdCheck() {
      // 完全新增
      if (!this.submitData.account) {
        this.showCheckBox = false
        this.checkedPwd = true
        return
      }
      // 從角色列表新增
      if (!this.defaultValue.id && this.submitData.account) {
        this.showCheckBox = true
        this.checkedPwd = false
        return
      }
      // 等同編輯角色
      if (this.defaultValue.id.length > 0 && this.submitData.account) {
        this.showCheckBox = true
        return
      }
    },
    /**
     * @description 因為會有修改角色直接儲存的問題，所以這邊要做驗證
     */
    validateSave() {
      let validate = true
      if (this.submitData.userGroupIds.includes(7)) return validate
      if (this.submitData.userGroupIds.includes(12) && this.submitData.userGroupStoreIds.length === 0) {
        this.$message({
          message: '請至基本資訊設定分店',
          type: 'error',
        })
        validate = false
      }
      return validate
    },
    /**
     * @description 美容師畫面儲存
     */
    async tryToStoreEmployee() {
      await this.$refs.form.validate()
      this.tryingStore = true;
      let submitData = Object.assign({}, this.submitData)
      submitData = formatSubmitData(submitData)
      await this.$store.dispatch('schedule/storeStaff', submitData)
      messageStore('edit')
      this.tryingStore = false
      this.emitStore()
    },
    async tryToStore() {
      await this.$refs.step.$refs.form.validate()
      if (this.accessType === 'employee') {
        await this.tryToStoreEmployee()
        return
      }
      if (this.activeStep === 4) {
        if (!this.$refs.step.validateServiceTree()) return
      }
      if (!this.validateSave()) return
      try {
        let submitData = { }
        if (!this.$refs.step) {
          submitData = Object.assign({}, this.submitData)
        } else {
          const result = this.$refs.step.filterSubmitData
          submitData = Object.assign({}, this.submitData, result)
        }
        submitData = Object.assign({}, formatSubmitData(submitData), {type: this.fetchTypes[0]})
        this.tryingStore = true;
        if (!this.isEditMode) {
          // 新增mode
          if (this.accountId) {
            const accountUser = await this.$store.dispatch('schedule/sendLinkUser', { userId: this.accountId })
            submitData.id = accountUser.id
          }
          const newStaff = await this.$store.dispatch('schedule/storeStaff', submitData)
          messageStore('add')
          notification('排班人員', '排班', 'schedule')
          this.emitStore(newStaff)
        } else {
          // 修改mode
          await this.$store.dispatch('schedule/storeStaff', submitData)
          await this.$store.dispatch('auth/fetchAccess') // 因為有可能分店管理者自己改分店，所以這邊重打一次權限
          messageStore('edit')
          this.emitStore()
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.tryingStore = false
      }
    },
    emitStore(newStaff = '') {
      this.$emit('store', newStaff)
      this.emitClose()
    },
    emitClose() {
      this.$emit('close')
      this.$refs.step.$refs.form.resetFields()
    },
    updateSubmitData() {
      this.submitData = formatToFormData(Object.assign({}, this.defaultValue))
    },
    async onClickNextStep(step) {
      await this.$refs.step.$refs.form.validate()
      if(step !== this.stepList.length) {
        await this.$refs.step.$refs.form.clearValidate()
        this.activeStep += 1
      } else {
        this.tryToStore()
      }

    },
    loadingStatusFunc(status) {
      this.loadingStatus = status
    },
    back() {
      this.activeStep--
    },
    async onClickLeave() {
      try {
        if(!this.isEditMode){
          await messageBoxLeave('人員')
          this.$refs.step.$refs.form.resetFields()
          this.$refs.step.$refs.form.clearValidate()
          this.$emit('close')
        }
        
        this.$refs.step.$refs.form.resetFields()
        this.$refs.step.$refs.form.clearValidate()
        this.$emit('close')
      } catch (error) {
      } finally {
      }
    },
  },
}
</script>

<template>
  <div :class="[$style.page, { isEmployeeMob: accessType === 'employee','isStyleDialog': isDialog }, $style.outPage, $style.pageContent]">
    <BaseSteps :active="activeStep" :list="stepList" :class="{ 'isStyleNormal': isDialog }"/>
      <el-card :class="$style['card-wrapper']" class="isStyleNormal bg-white">
        <!-- <keep-alive> -->
          <component :is="ScheduleStaffFormSettingStep[activeStep - 1]"
            ref="step" 
            v-model="submitData" 
            :submit-data="submitData"
            :class=" { 'isStyleDialogComponent': isDialog }"
            :all-user-groups="allUserGroups"
            :permission="hasBranchPermission" 
            :cached-products="cachedProducts" 
            :default-value="defaultValue"
          >
          </component>
        <!-- </keep-alive> -->
        <div :class="[$style.footer, { 'isStyleDialog': isDialog }]">
          <el-button class="is-round" data-tour-text="若不想新增此活動，請按「離開」跳出。注意：我們將不會保留此步驟填寫的資料。" @click="onClickLeave">離開</el-button>
          <el-button v-if="activeStep !== 1" class="is-round" data-tour-text="若不想新增此活動，請按「離開」跳出。注意：我們將不會保留此步驟填寫的資料。" @click="back">上一步</el-button>
          <el-button class="is-round" data-tour-text="若欄位皆已填寫完成，點擊「下一步」儲存此步驟填寫的資料，前往下一步" type="primary" :loading="tryingStore" @click="onClickNextStep(activeStep)">{{
            activeStep !== 4 ? '下一步' : '完成'
          }}</el-button>
        </div>
      </el-card>
  </div>
</template>
<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';
.pageContent {
  background-color: #F9FAFB;
  &:global {
    &.isStyleDialog {
      background-color: #fff;
      .el-card {
        &.isStyleNormal {
          min-height: auto;
          margin-bottom: 0;
          .isStyleDialogComponent {
            padding-bottom: 2rem;
          }
        }
      }
    }
  }
}
.thisPageCus {
  :global {
    .el-tabs__content {
      padding-top: 0;
    }
  }
}

:global {
  .isSchedule {
    position: static;
    width: 100%;
    left: 0;
    box-shadow: none;
    margin-top: 10px;
  }

  .el-tabs--border-card>.el-tabs__content {
    // padding-bottom: 0;
  }
}

:global {
  .el-page-header {
    align-items: center;
    font-size: 22px;
  }

  .el-page-header__left {
    border: 1px solid $color-border-for-bg-white;
    border-radius: $border-radius;
    padding: 12px 24px;
  }
}

.pageActive {
  padding: 0px;

  :global {
    .el-tabs__content {
      // padding-bottom: 0;
      // border: 1px solid red;
    }

    .el-page-header__left {
      background-color: white;
    }

    .el-tabs__header>.el-tabs__nav-wrap .el-tabs__nav .is-active {
      border-bottom: 2px solid $color-primary !important;
    }
  }
}

.outPage {
  margin: auto -15px;

  :global {
    .returnClass {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      :global {
        .el-button {
          margin-left: 8px;
        }
      }

      @include max-md {
        padding-top: 37px;
        padding-left: 20px;
      }

      @include max-sm {
        padding-top: 37px;
        padding-left: 20px;
      }
    }

    .employeeMobBtn {
      display: flex;
      justify-content: space-between;
      padding: 20px;

      :global {
        .el-button {
          width: 40%;
        }
      }
    }
  }
}

.pageBaseInfo {
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  // padding: 20px;
  :global {
    .basicInfoForMainPart {
      padding-left: 20px;
    }

    .imgPlacement {
      display: flex;
      justify-content: center;
    }
  }
}

.allPageStyle {
  padding: 20px 20px 100px;

  :global {
    .itemTitle {
      font-size: 14px;
      color: $color-secondary;
      font-weight: bold;
    }

    .smallAfterExitDay {
      :global {
        .el-form-item__label {
          &::after {
            content: '  任職結束即自動停權';
            font-size: 12px;
          }
        }
      }
    }
  }
}

.isEmployeeMob {
  margin-top: 24px;

  @include max-md {
    margin-top: 100px;
  }

  @include max-lg {
    margin-top: 100px;
  }

  @include max-sm {
    margin-top: 100px;
  }
}
</style>
